const en = {
  meta: {
    title: "Bale's — Iqbal Aulia, Creative Developer",
  },
  nav: {
    home: "Home",
    about: "About",
    services: "Services",
    journey: "Journey",
    contact: "Contact",
    templates: "Templates",
    switchLanguage: "Ganti ke Bahasa Indonesia",
  },
  home: {
    profileAlt: "Portrait of Iqbal Aulia",
    buildingDigital: ["building digital", "experiences"],
    craftingInnovative: ["crafting innovative", "digital solutions"],
    typing: ["Programming", "is not", "just"],
    quoteBody: [
      "about writing code",
      "it’s about solving problems with",
      "creativity and passion.",
    ],
    quoteFail: ["Don’t be afraid to fail", "be afraid not to try"],
    quoteAuthor: "Unknown",
    serviceIntro: [
      "I provide professional development services",
      "to help bring your ideas",
      "to life.",
    ],
    qualityCode: "Quality code",
    qualityFor: "for",
    qualityProject: "your project",
    serviceLines: [
      { label: "Front End", stack: "React · Vue · TS", note: "Pixel-perfect UI" },
      { label: "Back End", stack: "Node · REST · SQL", note: "Scalable APIs" },
      { label: "Full Stack", stack: "End-to-end", note: "Idea to launch" },
    ],
    explore: ["explore my recent", "projects"],
    showcasing: ["showcasing creative", "web solutions"],
    seeMore: "see more",
    tagline: ["Turning ideas", "into code, and", "visions into reality."],
  },
  services: {
    headerKicker:
      "advance website solution for landing page, blog, e-commerce, and more",
    headerTitle: ["[Digital", "Systems]"],
    contactUs: "Contact Us",
    yearsExperience: "Years Experience",
    featuresTitle: "what are our features ?",
    featureBody:
      "Managing the creation & maintenance of websites, from planning, design, coding, testing, to launch.",
    features: [
      "Free Domain + SSL",
      "Modern Design",
      "SEO Friendly",
      "Responsive Website",
      "Copywriting",
    ],
    growthTotal:
      "Over the years, I have successfully completed more than 25 projects, demonstrating expertise and dedication in delivering the best solutions. My portfolio includes a wide range of projects, from mobile applications to comprehensive website development. Each project is a testament to my commitment to quality and innovation.",
    growthMobile:
      "I am proud to have completed more than 10 high-quality mobile application projects. Each application is designed to provide an exceptional user experience and meet specific client needs.",
    growthWebsite:
      "I have completed more than 15 high-quality website development projects. Each website is designed to provide an exceptional user experience and meet specific client needs.",
    toolsProject: "Tools Project",
    skillsTitle: "Skills & Expertise",
    skillsBody: [
      "My skillset includes various areas of technology and development,",
      "from frontend to backend, ensuring comprehensive solutions",
      "for your project needs.",
    ],
    teams: ["Marketing", "Server", "Design", "SEO", "Developer"],
    packagesTitle: "Best Packages",
    packagesBody:
      "Discover packages designed around what your business actually needs. Transparent pricing, production-grade code, and support until your site is live.",
    packagePrefix: "Package",
    detail: "Detail",
    orderNow: "Order Now!",
    customTitle: "Custom Website",
    customBody:
      "Want a website that truly fits your business needs? We offer custom website development services that can be discussed according to your preferences. Get the right and unique solution for your business by discussing with our expert team!",
    customTemplateHint: "Smaller budget? Start from a ready-made template at",
    discuss: "Discuss With Us",
    orderMessage: (pkg: string, price: string) =>
      `Hello!\nMy name is ....\nI would like to inquire about website development services with the ${pkg} package (${price}).\n\nOrder Details:\nName: ......\nPackage: ${pkg}\nEmail: ......\nPhone / WhatsApp: .....\nLanding Page / Company Profile: .....`,
    customMessage:
      "Hello!\nMy name is ....\nI would like to inquire about custom website development services.\n\nOrder Details:\nName: ......\nEmail: ......\nPhone / WhatsApp: .....\nCustom Website Details: .....",
  },
  about: {
    headline: ["passionate", "about", "creating", "amazing web", "experiences"],
    name: "Alex Johnson",
    pictureAlt: "Portrait",
    describe: [
      "As a Front-end web developer, I bring a passion for coding and a commitment to delivering high-quality, responsive websites to my clients. With extensive experience in HTML, CSS, and JavaScript / TypeScript, I am skilled in creating visually appealing and user-friendly interfaces that meet the needs of businesses and organizations of all sizes.",
      "I have a strong understanding of user experience design principles and use this knowledge to create engaging websites that are easy to navigate and optimized for search engines. I am also adept at using a range of Front-end development tools and frameworks such as React and Vue.js, which allows me to create powerful and dynamic web applications.",
      "My ability to work collaboratively with clients and colleagues to understand their needs and deliver tailored solutions is a hallmark of my work. Whether working on large-scale projects or individual assignments, I pride myself on my attention to detail, my ability to meet tight deadlines, and my commitment to producing clean, maintainable code.",
    ],
    tools: "Tools",
    currentPosition: "Current Position",
    quote:
      "\" Sometimes we have to go deep inside ourselves to solve problems.\" - Patrick Star",
    testimonialBy: "testimonial by",
    followUs: "Follow Us",
  },
  contact: {
    kicker: "get in touch",
    title: ["let's chat, reach out", "to Us"],
    body: "have questions or feedback ? We're here to help. Send us a message, and we'll respond within 24 hours.",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email Address",
    message: "Messages",
    send: "Send Message!",
    waMessage: (name: string, email: string, message: string) =>
      `Hello!\nMy name is ${name}.\nEmail: ${email}\nMessage:\n${message}`,
  },
  history: {
    title: "Experiences",
    description: [
      "This page showcases the various experiences and",
      "projects that I have been involved in throughout my career.",
      "Here, you can find detailed information about",
      "my professional journey, skills, and accomplishments.",
    ],
    professional: "Professional",
    freelance: "Freelance",
    detail: "Detail",
    present: "Present",
    emptyState: (type: string) => `${type} projects will be updated soon.`,
    workType: {
      Hybrid: "Hybrid",
      Remote: "Remote",
      Onsite: "Onsite",
    } as Record<string, string>,
    employmentType: {
      "Full-time": "Full-time",
      Internship: "Internship",
      Freelance: "Freelance",
    } as Record<string, string>,
  },
  footer: {
    about: "about",
    service: "service",
    templates: "templates",
    contact: "contact us",
    newsletter:
      "receive valuable industry insight & if you have any questions feel free to contact us",
    emailPlaceholder: "Enter Your Email",
  },
  whatsapp: {
    alt: "Chat on WhatsApp",
    message:
      "Hi Iqbal!\nMy name is ... and I would like to ask about your website development services.",
  },
  empty: {
    message: [
      "Oops! The page you are looking for does not exist.",
      "It might have been moved or deleted.",
    ],
  },
};

export type Dictionary = typeof en;
export default en;
